import React, { useContext } from "react";
import Tab from "../../components/tab"
import Faturas from "./faturas"
import Boletos from "./boletos"

import {
  Container
} from "./styles";


import { IRows } from "../../@interfaces";
import APIFinanceiro from "../../services/APIFinanceiro";


const Financeiro: React.FC = () => {

  async function getBoletoFile(dataRow: IRows){
    try {
      const response = await APIFinanceiro.getBoletoDownload({ Arquivos: [parseInt(dataRow!.arquivo)]});

      if(!response.error && response.listaArquivo) {
        return { base64: response.listaArquivo[0].conteudo};
      }else{
        return { errorMessage: response.message };
      }

    }catch{
      return { errorMessage: "Algo deu errado"};
    }
  }


  return (
    <Container>
      <Tab
        tabs={[
          {
            name: "Faturas",
            component: <Faturas getBoletoFile={getBoletoFile} />
          },
          {
            name: "Boletos",
            component: <Boletos getBoletoFile={getBoletoFile}/>
          },
        ]}
      />
    </Container>
  )
}

export default Financeiro;